import { Card, Table, Tag, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

interface RdaRow {
  id: number
  codice?: string
  work_order_id?: number
  cliente_nome?: string
  targa?: string
  fornitore?: string
  data_consegna_prevista?: string
}

const columns = [
  {
    title: 'RDA',
    dataIndex: 'codice',
    key: 'codice',
    width: 130,
    render: (v: string, r: RdaRow) => (
      <Space size={4}>
        <span style={{ fontWeight: 600, color: '#1677ff' }}>{v ?? '—'}</span>
        {r.cliente_nome && <span style={{ color: '#888', fontSize: 12 }}>· {r.cliente_nome}</span>}
      </Space>
    ),
  },
  {
    title: 'Veicolo',
    dataIndex: 'targa',
    key: 'targa',
    width: 100,
    render: (v: string) => v ? <Tag color="geekblue">{v}</Tag> : '—',
  },
  {
    title: 'Fornitore',
    dataIndex: 'fornitore',
    key: 'fornitore',
    ellipsis: true,
    render: (v: string) => v ?? '—',
  },
  {
    title: 'Consegna prevista',
    dataIndex: 'data_consegna_prevista',
    key: 'data_consegna_prevista',
    width: 120,
    render: (v: string) => v ? new Date(v).toLocaleDateString('it-IT') : '—',
  },
]

export function TableOrdiniInAttesaWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<RdaRow[]>({
    queryKey: ['dashboard', 'ordini-in-attesa-list'],
    queryFn: async () => {
      const res = await axiosInstance.get('/purchase-requests/', {
        params: { stato_nome: 'Ordinata', limit: 20 },
      })
      return Array.isArray(res.data) ? res.data : []
    },
    staleTime: 30000,
  })

  return (
    <Card size="small" title="Ordini in attesa di ricevimento">
      <Table
        columns={columns}
        dataSource={data ?? []}
        rowKey="id"
        size="small"
        loading={isLoading}
        pagination={false}
        scroll={{ x: 480 }}
        locale={{ emptyText: 'Nessun ordine in attesa' }}
        onRow={() => ({
          onClick: () => navigate('/ordini'),
          style: { cursor: 'pointer' },
        })}
      />
    </Card>
  )
}
